<template>
    <footer class="footer has-cards">
        <!--        <div class="container container-lg">-->
        <!--            <div class="row">-->
        <!--                <div class="col-md-6 mb-5 mb-md-0">-->
        <!--                    <div class="card card-lift&#45;&#45;hover shadow border-0">-->
        <!--                        <router-link to="/landing" title="Landing Page">-->
        <!--                            <img v-lazy="'img/theme/landing.jpg'" class="card-img">-->
        <!--                        </router-link>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="col-md-6 mb-5 mb-lg-0">-->
        <!--                    <div class="card card-lift&#45;&#45;hover shadow border-0">-->
        <!--                        <router-link to="/profile" title="Profile Page">-->
        <!--                            <img v-lazy="'img/theme/profile.jpg'" class="card-img">-->
        <!--                        </router-link>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Thank you for choosing us!</h3>
                    <h4 class="mb-0 font-weight-light">We will keep updating our system.</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
<!--                    <a target="_blank" rel="noopener" href="https://cognsoft.com"-->
<!--                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"-->
<!--                       data-original-title="Follow us">-->
<!--                        <i class="fa fa-twitter"></i>-->
<!--                    </a>-->
                    <a target="_blank" rel="noopener" href="https://www.linkedin.com/in/yuanyisun/"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-linkedin"></i>
                    </a>
<!--                    <a target="_blank" rel="noopener" href="https://cognsoft.com"-->
<!--                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"-->
<!--                       data-original-title="Follow us">-->
<!--                        <i class="fa fa-dribbble"></i>-->
<!--                    </a>-->
<!--                    <a target="_blank" rel="noopener" href="https://cognsoft.com"-->
<!--                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"-->
<!--                       data-original-title="Star on Github">-->
<!--                        <i class="fa fa-github"></i>-->
<!--                    </a>-->
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="https://HKHK.US" target="_blank" rel="noopener">HKHK.US</a> & <a
                            href="https://www.cognsoft.com" target="_blank" rel="noopener">CognSoft.com</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
<!--                        <li class="nav-item">-->
<!--                            <a href="https://www.cognsoft.com" class="nav-link" target="_blank" rel="noopener">Creative-->
<!--                            </a>-->
<!--                        </li>-->
                        <li class="nav-item">
                            <a href="https://www.cognsoft.com" class="nav-link" target="_blank"
                               rel="noopener">About
                                Us</a>
                        </li>
<!--                        <li class="nav-item">-->
<!--                            <a href="http://www.cognsoft.com" class="nav-link" target="_blank"-->
<!--                               rel="noopener">Blog</a>-->
<!--                        </li>-->
<!--                        <li class="nav-item">-->
<!--                            <a href="https://www.cognsoft.com/LICENSE.md"-->
<!--                               class="nav-link" target="_blank" rel="noopener">MIT License</a>-->
<!--                        </li>-->
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        name: 'app-footer',
        data() {
            return {
                year: new Date().getFullYear()
            }
        }
    };
</script>
<style>
</style>
